import Download_app from "../common/download-app/Download_app";
import Banner from "./banner/Banner";
import "./banner/Banner.css";
import User_Reviews from "./user-reviews/User_Reviews";
import Who_can_use from "./who-can-use/Who_can_use";
import Why_choose from "./why-choose/Why_choose";

function Home() {
  return (
    <>
      <Banner />
      <Why_choose />
      <Who_can_use />
      <User_Reviews/>
      <Download_app/>
    </>
  );
}

export default Home;
